// member-portal/src/components/promoter/ReferralLinkGenerator.jsx
// NEW COMPONENT — Reusable referral link display + copy button (isolated, no existing files touched)

import React, { useState } from 'react';
import './ReferralLinkGenerator.css';

const ReferralLinkGenerator = ({ referralUrl, onCopySuccess }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!referralUrl) return;

    try {
      await navigator.clipboard.writeText(referralUrl);
      setCopied(true);
      if (onCopySuccess) onCopySuccess();
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy referral link:', err);
      alert('Failed to copy link. Please copy manually.');
    }
  };

  return (
    <div className="referral-link-generator">
      <h3>Your Unique Referral Link</h3>
      
      <div className="link-container">
        <input
          type="text"
          value={referralUrl || 'Loading your referral link...'}
          readOnly
          className="referral-input"
          placeholder="Your referral link will appear here"
        />
        <button
          onClick={handleCopy}
          className={`copy-button ${copied ? 'copied' : ''}`}
          disabled={!referralUrl}
          aria-label="Copy referral link to clipboard"
        >
          {copied ? 'Copied!' : 'Copy Link'}
        </button>
      </div>

      <p className="share-hint">
        Share this link with restaurant owners — earn commission when they sign up and start generating revenue on Scover!
      </p>

      {copied && (
        <p className="copy-success-message">
          Link copied to clipboard! Ready to share.
        </p>
      )}
    </div>
  );
};

export default ReferralLinkGenerator;